export const formatCPFNumber = (value: string): string => {
  if (!value) return ''
  const cpf = value.replace(/[^\d]/g, '').substring(0, 11)
  const cpfLength = cpf.length
  let maskedCPF = cpf.substring(0, 3)
  if (cpfLength > 3) maskedCPF += '.' + cpf.substring(3, 6)
  if (cpfLength > 6) maskedCPF += '.' + cpf.substring(6, 9)
  if (cpfLength > 9) maskedCPF += '-' + cpf.substring(9, 11)
  return maskedCPF
}

export const formatCNPJNumber = (value: string): string => {
  if (!value) return ''
  const raw = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
  // Posições 1-12: alfanumérico | Posições 13-14 (dígitos verificadores): numérico apenas
  const base = raw.substring(0, 12)
  const checkDigits = raw.substring(12).replace(/\D/g, '').substring(0, 2)
  const cnpj = base + checkDigits
  const cnpjLength = cnpj.length
  let maskedCNPJ = cnpj.substring(0, 2)
  if (cnpjLength > 2) maskedCNPJ += '.' + cnpj.substring(2, 5)
  if (cnpjLength > 5) maskedCNPJ += '.' + cnpj.substring(5, 8)
  if (cnpjLength > 8) maskedCNPJ += '/' + cnpj.substring(8, 12)
  if (cnpjLength > 12) maskedCNPJ += '-' + cnpj.substring(12, 14)
  return maskedCNPJ
}
